import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 获取部门列表
  getDepartments: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/departments`, "get", config),
  // 新建部门
  postDepartments: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/departments`, "post", config),
  // 获取部门详情
  getDepartmentDetail: (realmName, id, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/departments/${id}`,
      "get",
      config
    ),
  // 编辑部门
  putDepartmentDetail: (realmName, id, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/departments/${id}`,
      "put",
      config
    ),
  // 删除部门
  deleteDepartment: (realmName, id, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/departments/${id}`,
      "delete",
      config
    ),
  // 部门成员信息
  getDepartmentMembers: (realmName, id, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/departments/${id}/members`,
      "get",
      config
    ),
  // 设置部门信息
  putDepartmentMembers: (realmName, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/departments`,
      "put",
      config
    ),
  // 部门成员信息
  getDepartmentAuthClients: (realmName, id, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/departments/${id}/clients/roles`,
      "get",
      config
    ),
  // 给部门授权应用
  putDepartmentAuthClients: (realmName, id, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/departments/${id}/clients`,
      "put",
      config
    ),
  // 给应用授权角色 参数分别为：企业code、部门id、应用id
  putDepAuthCliRoles: (realmName, did, id, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/departments/${did}/clients/${id}/roles`,
      "put",
      config
    )
}
